import { Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { DevoAreaService } from '../../../devo-area.service';
import { DevoPipelinePageService } from '../../devo-pipeline.page.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'devo-pipeline-staff-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './devo-pipeline-staff-view.part.html',
})
export class DevoPipelineStaffViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly areaService = inject(DevoAreaService);
	private readonly pageService = inject(DevoPipelinePageService);

	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public staff = computed(() => {
		return [];
	});
}